import { Component, forwardRef, Inject, Input } from '@angular/core';
import { BlockUI, NgBlockUI }                   from 'ng-block-ui';
import { NgbActiveModal }                       from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }                     from '@ngx-translate/core';

import { CustomerModel }    from './models/customer';
import { CustomersService } from './customers.service';
import { MessagesService }  from '../messages/messages.service';
import { Table }            from '../table/types/table';

@Component({
  selector   : 'wor-resolve-customer-matches',
  template: require('./customer.resolve-matches.component.html')
})
export class ResolveCustomerMatchesComponent {
  @BlockUI('resolveCustomerMatchesBlock') block: NgBlockUI;

  @Input() customer: CustomerModel;
  @Input() matches : Array<CustomerModel> = [];

  selectedCustomer: CustomerModel | null = null;

  tableSettings: Table = {
    columns: [
      {
        field : 'display_name',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.NAME')
        }
      },
      {
        field : 'phone',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.PHONE')
        },
        pipe: 'phone'
      },
      {
        field : 'mobile',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.MOBILE')
        },
        pipe: 'mobilePhone'
      },
      {
        field : 'email',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.EMAIL')
        }
      },
      {
        field : 'address1',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.ADDRESS')
        }
      },
      {
        field : 'address2',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.ADDRESS')
        }
      },
      {
        field : 'suburb',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.SUBURB')
        }
      },
      {
        field : 'state',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.STATE')
        }
      },
      {
        field : 'postcode',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.POSTCODE')
        }
      }
    ],
    empty: {
      text: this.translateService.instant('GENERAL_SPACE.STATUS.NO_RESULTS')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    }
  };

  constructor (
    public  activeModal     : NgbActiveModal,
    @Inject(forwardRef(() => CustomersService))
    private customersService: CustomersService,
    private messagesService : MessagesService,
    private translateService: TranslateService
  ) {}

  confirm () : void {
    if ( !this.selectedCustomer ) {
      return;
    }

    this.block.start();

    this.customersService.saveMatch(this.customer, this.selectedCustomer)
      .then(() => this.activeModal.close())
      .catch(error => this.messagesService.error(error))
      .finally(() => this.block.stop());
  }

  select ( customer : CustomerModel ) : void {
    this.selectedCustomer = customer.selected
      ? customer
      : null;
  }
}
